import React from "react";
import {
  Grid,
  Select,
  MenuItem,
  FormControlLabel,
  Checkbox,
} from "@material-ui/core";

const todayDate = new Date();
const Options = [
  { name: Ext.Date.format(todayDate, "M j, Y g:iA"), val: "M j, Y g:iA" },
  { name: Ext.Date.format(todayDate, "n/j/Y g:iA"), val: "n/j/Y g:iA" },
  { name: Ext.Date.format(todayDate, "Y/n/j g:iA"), val: "Y/n/j g:iA" },
  { name: Ext.Date.format(todayDate, "D, M j g:iA"), val: "D, M j g:iA" },
];

function DateTimeColumnConfig({
  values,
  handleChange,
  setFieldValue,
  valuesPath = "",
  isOnlyFormattingConfig,
}) {
  React.useEffect(() => {
    if (values.options.format) {
      return;
    }
    setFieldValue(`${valuesPath}options.format`, "M j, Y g:iA");
  }, [setFieldValue, values.options.format, valuesPath]);

  return (
    <React.Fragment>
      <Grid item xs={12}>
        <Select
          name={`${valuesPath}options.format`}
          value={values.options.format ?? ""}
          onChange={handleChange}
          // label="Comma Format"
          variant="outlined"
          style={{ width: 200 }}
        >
          {Options.map((option) => (
            <MenuItem value={option.val}>{option.name}</MenuItem>
          ))}
        </Select>
      </Grid>
      {!isOnlyFormattingConfig && (
        <>
          <Grid item xs={12}>
            <FormControlLabel
              control={
                <Checkbox
                  size="small"
                  color="primary"
                  name={`${valuesPath}options.default_current_time`}
                  checked={values.options.default_current_time ?? ""}
                  onChange={handleChange}
                />
              }
              label={"Default as Current Time"}
            />
          </Grid>
          {values.options.default_current_time && (
            <Grid item xs={12}>
              <FormControlLabel
                control={
                  <Checkbox
                    size="small"
                    color="primary"
                    name={`${valuesPath}options.allow_free_text`}
                    checked={!values.options.allow_free_text}
                    onChange={() =>
                      setFieldValue(
                        `${valuesPath}options.allow_free_text`,
                        !values.options.allow_free_text
                      )
                    }
                  />
                }
                label={"Do not allow to change Time"}
              />
            </Grid>
          )}
        </>
      )}
    </React.Fragment>
  );
}

export default DateTimeColumnConfig;
